module.exports = __webpack_public_path__ + "media/shot-hit.754428e9.mp3";